import { InteractionOutlined } from "@ant-design/icons";
import { DATE_FORMAT_MMDDYYYY_HHMM_A, DateUtils } from "utils/dateutils";

export default function FeatureHistoryItem({ history }: { history: any }) {
  const createdAt = DateUtils.format(
    history.created_at,
    DATE_FORMAT_MMDDYYYY_HHMM_A
  );

  return (
    <div
      className="leading-relaxed tracking-wide"
      data-testid="feature-history-item"
    >
      <div
        className="flex justify-between"
        data-testid="feature-history-item-header"
      >
        <InteractionOutlined data-testid="feature-history-item-icon" />
        <div
          className="text-xs text-neutral-600"
          data-testid="feature-history-item-date"
        >
          {createdAt}
        </div>
      </div>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: history?.action_description_html }}
        data-testid="feature-history-item-description"
      />
    </div>
  );
}
